import {
  CardNumberElement,
  useElements,
  useStripe,
} from '@stripe/react-stripe-js';
import { SetupIntentResult } from '@stripe/stripe-js';
import { useMutation } from '@tanstack/react-query';
import { FC, useState } from 'react';
import { setupPaymentMethod } from '../../../services/user';
import { CardForm } from './CardForm';

interface Props {
  onSuccess: (setupIntent: SetupIntentResult) => void;
}

export const AddCardForm: FC<Props> = ({ onSuccess }) => {
  const [error, setError] = useState('');
  const stripe = useStripe();
  const elements = useElements();

  const { mutate, isPending } = useMutation({
    mutationFn: async () => {
      setError('');
      const { data, ok } = await setupPaymentMethod({
        method: 'card',
      });
      if (ok) {
        const card = elements!.getElement(CardNumberElement);
        const result = await stripe!.confirmCardSetup(data.token, {
          payment_method: { card: card! },
        });

        if (result.error) {
          return setError(result.error.message!);
        }
        onSuccess(result);
      } else {
        setError('cardForm.error');
      }
    },
  });

  const onChange = () => {
    setError('');
  };

  return (
    <CardForm
      isLoading={isPending}
      onChange={onChange}
      error={error}
      onSubmit={() => mutate()}
    />
  );
};
